import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { getStaffByRequestId, updateStatus, getVehicleByRequestId, rejectRequest, cancelRequest} from "../../services/request.service";
import './../../assets/detailRequest.css'
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import PersonalItem from "../../Components/personalItem/PersonalItem";
import VehiclesItem from "../../Components/vehicles/VehiclesItem";

const DetailRequest = ({ setIsOpen, requestId, requestTitle , requestCurrentStatus, requestInitialDate,requestFinalDate, requestNumber, setShowRequest, description, requestUserName }) => {
  
  let navigate = useNavigate();
  const dispatch = useDispatch();
  let [staff, setStaffs] = useState([]);
  let [vehicle, setVehicles] = useState([]);
  const [successful, setSuccessful] = useState(false);
  const [showButton, setShowButton] = useState(false);
  let [coment, setComent] = useState();

  const {user: user} = useSelector((state) => state.auth)
  const userRoles = user?.roles
  const isSuperAdmin = userRoles?.includes('SuperAdmin');
  const isApprover = userRoles?.includes('Approver');
  const isSecondApprover = userRoles?.includes("SecondApprover");
  const isClient = userRoles?.includes('Client');

  /*  */


  const showAlert = (adMesagge, suMessage, solMesage, cancelMessage, handleFunction) => {
    Swal.fire({
      title: "Advertencia",
      text: adMesagge,
      icon: "info",
      showDenyButton: true,
      denyButtonText: "No",
      confirmButtonText:"Si",
      confirmButtonColor: "#3085d6",
    }).then(response => {
      if(response.isConfirmed){
        handleFunction();
        window.location.reload();
        Swal.fire({
          title: solMesage,
          text: suMessage,
          icon: "success",
          confirmButtonText:"Ok",
          confirmButtonColor: "#3085d6",
        })
      }else{
        Swal.fire({
          title: "Cancelado",
          text: cancelMessage,
          icon: "error",
          confirmButtonText:"Ok",
          confirmButtonColor: "#3085d6",
        })
      }

    });
  }

  useEffect(()=>{
    (async () => {
      const requestStaff = await getStaffByRequestId(requestId);
      setStaffs(requestStaff);
      const requestVehicle = await getVehicleByRequestId(requestId);
      setVehicles(requestVehicle);
    })();
  },[])

  useEffect(() => {
    if(requestCurrentStatus === 'Canceled'){
      setShowButton(false)
    }else{
      setShowButton(true)
    }
  },[requestCurrentStatus])

  const currentStatus = {
    ['OnApprovation'] : 'En aprobacion.',
    ['Approved']: 'Aprobado',
    ['Rejected']: 'Rechazado',
    ['Created']:  'Creado',
    ['Imcomplete']: 'Incompleto',
    ['Completed']:  'Completado',
    ['Canceled']: 'Anulada',
  }

  const handleSubmitAprove = (e) => {
    setSuccessful(false);
    setIsOpen(false);
    setShowRequest(true);
    dispatch(updateStatus(requestId, coment))
  }

  const handleSubmitReject = () => {
    setSuccessful(false);
    setIsOpen(false);
    setShowRequest(true);
    dispatch(rejectRequest(requestId, coment))
  }

  const handleCancelRequest = (e) => {
    setSuccessful(false);
    setIsOpen(false);
    setShowRequest(true);
    setShowButton(false)
    dispatch(cancelRequest(requestId), window.location.reload())
  }

  const handleInputChange = (e) => {
    setComent(e.target.value);
  }

  console.log(vehicle)

  return (
    <div>
      <div onClick={() => setIsOpen(false)} />
      <div className="card">
        <div className="card-content">
          <div
            className="card-header"
            style={{ display: "flex", justifyContent: "space-between" }}
          >
            <h6>{`Solicitud #${requestNumber}`}</h6>
            <h6>{`Estado: ${currentStatus[requestCurrentStatus]}`}</h6>
          </div>
          <div className="card-body">
            <div>
              <div style={{ display: "flex", justifyContent: "center" }}>
                <h3 className="h3-detail">{requestUserName}</h3>
              </div>
              <div>
                <h6 style={{display: 'flex', justifyContent: "center"}}>
                  {requestTitle}
                </h6>
              </div>
              <div className="date-request">
                <span className="card-text" style={{ marginRight: "15px" }}>
                  <i className="bi bi-calendar ">
                    {" "}
                    {`Inicio de la visita: ${requestInitialDate}`}
                  </i>
                </span>
                <span className="card-text">
                  <i className="bi bi-calendar">
                    {" "}
                    {`Fin de la visita: ${requestFinalDate}`}
                  </i>
                </span>
              </div>
              <hr></hr>
            </div>
            <div className="request-description">
              <h5>Descripcion de la solicitud:</h5>
              <span className="card-text">{`${description}`}</span>
            </div>
            <div style={{ display: "flex" }}>
              <div className="staffs-title">Personal:</div>
              <div className="vehicle-title">Vehiculos:</div>
            </div>
            <div className="staffs-vehicles-container">
              <div className="staffs-container">
                {staff.map((oneStaff) => (
                  <PersonalItem oneStaff={oneStaff} />
                ))}
              </div>
              <div className="vehicles-container">
                {vehicle.map((oneVehicle) => (
                  <VehiclesItem oneVehicle={oneVehicle} />
                ))}
              </div>
            </div>
            <hr />
          </div>
          {(isSuperAdmin || isApprover || isSecondApprover) && (
            <form className="form-container">
              <div className="mb-3 row">
                <div className="col-sm-10">
                  <label
                    htmlFor="comments"
                    className="form-label"
                    style={{ fontSize: "18px", paddingLeft: "12px" }}
                  >
                    <span className="text-span">Comentarios:</span>
                  </label>
                </div>
                <div className="col-sm-12" style={{ paddingLeft: "22px" }}>
                  <textarea
                    style={{ paddingLeft: "20px" }}
                    name="comments"
                    className="form-control"
                    id="exampleFormControlTextarea1"
                    rows={2}
                    defaultValue={""}
                    onChange={handleInputChange}
                  />
                </div>
              </div>
              <div className="div-Buttons">
                <button
                  className="btn btn-success buttons btn-sm"
                  name={requestId}
                  onClick={(e) => {
                    e.preventDefault();
                    showAlert(
                      "Confirma aprobar la solicitud?",
                      "",
                      `la solicitud #${requestNumber} ha sido aprobada`,
                      `Se cancelo aprobar la solicitud`,
                      handleSubmitAprove
                    );
                  }}
                >
                  <i className="bi bi-check"> Aprobar</i>
                </button>
                <button
                  className="btn btn-danger buttons btn-sm"
                  onClick={(e) => {
                    e.preventDefault();
                    showAlert(
                      "Confirma rechazar la solicitud?",
                      "",
                      `la solicitud #${requestNumber} ha sido rechazada`,
                      `Se cancelo rechazar la solicitud`,
                      handleSubmitReject
                    );
                  }}
                >
                  <i className="bi bi-x"> Rechazar</i>
                </button>
                <button
                  className="btn btn-dark buttons btn-sm"
                  onClick={(e) => {
                    e.preventDefault();
                    setIsOpen(false);
                    setShowRequest(true);
                  }}
                >
                  <i className="bi bi-x"> Cancelar</i>
                </button>
              </div>
            </form>
          )}
          {isClient && (
            <div className="div-Buttons">
              <button
                className={`btn btn-danger btn-sm ${showButton ? "show-button" : "no-show-button"}`}
                onClick={(e) => {
                  e.preventDefault();
                  showAlert(
                    "Confirma anular la solicitud?",
                    "",
                    `la solicitud #${requestNumber} ha sido anulada`,
                    `Se cancelo anular la solicitud`
                  );
                  handleCancelRequest();
                }}
              >
                <i className="bi bi-x">Anular solicitud</i>
              </button>
              <button
                className="btn btn-dark buttons btn-sm"
                onClick={() => {
                  setIsOpen(false);
                  setShowRequest(true);
                }}
              >
                <i className="bi bi-x">Volver</i>
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default DetailRequest;